package de.oevbs.kunde.kundenportal2.model.services.claims

import de.oevbs.businesspartner.bpcrmservice2.claim.model.ClaimList
import de.oevbs.kunde.kundenportal2.ServiceInfo
import de.oevbs.sfa.communication.ClientDefinition
import de.oevbs.sfa.communication.ClientResponse

abstract class ClaimsClientDefinition(origin: String) : ClientDefinition(ServiceInfo, origin, ServiceInfo.name) {

     override val requestTimeoutMillis: Long = 30000L

    /**
     * Läd alle Schäden des eingeloggten Users/Partners und gibt sie als [ClaimList] zurück.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun init(): ClientResponse<ClaimList> = get("/claims/init")
}